<script lang="ts" setup>
	import type { TableRowSelection } from 'ant-design-vue/lib/table/interface'
	import type { AutoPendingPolicy } from '~/types'

	const props = defineProps<{
		records: AutoPendingPolicy['pendingPolicies']
		recordColumn?: TableColumn
		actionBtnText?: string
		rowSelection?: TableRowSelection<unknown>
		status?: string
		isLoading?: boolean
		isComprehensive: boolean
	}>()

	const custodianRecord = computed(() =>
		props.records.map((item, i) => {
			const { meta, ...rest } = item
			return { ...rest, ...item.meta, id: item?.id, key: i }
		})
	)
	const { currencyToNaira } = useCurrency()

	const {
		policiesTableColumn: { auto }
	} = useProducts()

	const emits = defineEmits<{
		(event: 'change', param: RecordSchema): void
	}>()
	const getStaff = (arg: RecordSchema) => {
		emits('change', arg)
	}
</script>

<template>
	<div>
		<shared-table-loader v-slot="{ columns }" :loading="isLoading" :columns="recordColumn || auto">
			<a-table :row-selection="rowSelection" :columns="columns" :data-source="custodianRecord">
				<template #bodyCell="{ column, record, index }">
					<slot :column="column" :record="record" :index="index">
						<span v-if="column.dataIndex === 'sn'">{{ index + 1 }}</span>
						<span v-if="column.dataIndex === 'vehicle_type'">
							{{ record?.vehicle_type?.name || record?.vehicle_type || 'N/A' }}
						</span>
						<span v-if="column.dataIndex === 'plate_number'">
							{{ record?.plate_number || record?.vehicle_registration_number || 'N/A' }}
						</span>
						<span v-if="column.dataIndex === 'model'">
							{{ record?.vehicle_model?.name || record?.vehicle_model || 'N/A' }}
						</span>
						<span v-if="column.dataIndex === 'manufacturer'">
							{{ record?.vehicle_make?.name || record?.vehicle_make || 'N/A' }}
						</span>
						<span v-if="column.dataIndex === 'custodian'">
							{{ record?.first_name || record?.meta?.first_name }}
							{{ record?.last_name || record?.meta?.last_name }}
						</span>

						<span v-if="column.dataIndex === 'value'">
							{{ currencyToNaira(record?.vehicle_value || record?.price || 0) }}
						</span>
						<my-cover-plan-status
							v-if="column.key === 'status'"
							:pending="!record?.policy_number"
							:plan-details="record || null"
						/>
						<button
							v-if="column.dataIndex === 'details'"
							type="button"
							aria-label="activate staff"
							aria-roledescription="view beneficiary plan details"
							class="text-sm font-medium"
							@click="getStaff(record)"
						>
							<span class="font-medium text-primary-2">
								<slot name="action-btn">
									{{ actionBtnText || 'Activate' }}
								</slot>
							</span>
						</button>
					</slot>
				</template>
			</a-table>
		</shared-table-loader>
	</div>
</template>
